




















































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { IBasketRoute } from "@/models/baskets";
import Context from "@/mixins/context";

@Component({
  components: {
    "basket-provider": () =>
      import("@/components/app/global/baskets/basket/basketProvider.vue"),
    "basket-provisioning-provider": () =>
      import("@/components/app/global/baskets/basket/provisioningProvider.vue"),
    "shop-provider": () =>
      import("@/components/app/global/baskets/basket/shopProvider.vue"),
    "basket-topper": () =>
      import("@/components/app/global/baskets/basket/basketTopper.vue"),
    "basket-notifications": () =>
      import("@/components/app/global/baskets/basket/basketNotifications.vue"),
    "basket-stepper": () =>
      import("@/components/app/global/baskets/basket/basketStepper.vue"),
    "basket-button": () =>
      import("@/components/app/global/baskets/basket/basketButton.vue"),
    "basket-currency-switcher": () =>
      import(
        "@/components/app/global/baskets/basket/basketCurrencySwitcher.vue"
      )
  }
})
export default class Basket extends Mixins(Context) {
  // Props

  @Prop({ required: true })
  public basketRoutes!: IBasketRoute[];

  @Prop({ default: "" })
  public routeClientId!: string | number;

  @Prop({ default: "" })
  public routeAccountId!: string | number;

  @Prop({ default: "" })
  public routeBasketId!: string | number;

  @Prop({ default: "" })
  public routeOrderId!: string | number;

  @Prop({ default: 0 })
  public billingTerm!: number;

  @Prop({ default: 1 })
  public quantity!: number;

  @Prop({ default: "" })
  public routeCurrencyCode!: string;

  @Prop({ default: "" })
  public routeCoupons!: string;

  @Prop({ default: false })
  public routeCrossSell!: boolean;

  @Prop({ default: false })
  public routeReadMore!: boolean;
}
